window.addEventListener('load', (event) => {
  let monthFrequency = document.querySelectorAll('.subs-frequency .freq-options label > input');

  // subscription and one-time inputs
  let purchaseOptions = document.querySelectorAll('.subs-box-options label.option-card > input');
  let sellingPlanInput = document.querySelector('.bundle_product_form input[name="selling_plan"]');

  monthFrequency.forEach((input) => {
    input.addEventListener('change', function () {
      let sellingID = this.getAttribute('data-selling-id');
      if (sellingPlanInput) {
        sellingPlanInput.value = sellingID;
      }
    });
  });

  if (document.querySelector('.subs-box-options label.option-card > input')) {
    let currentSelected = document.querySelector('.subs-box-options label.option-card > input:checked').value;
    if (currentSelected == 'subscription_op') {
      if (document.querySelector('.ad-bundles')) {
        document.querySelector('.ad-bundles').classList.remove('onetime_activate');
        document.querySelector('.ad-bundles').classList.add('subscription_activate');
      } else {
        document.querySelector('.ad-bundles').classList.remove('subscription_activate');
        document.querySelector('.ad-bundles').classList.add('onetime_activate');
      }
    }
  }

  purchaseOptions.forEach((input) => {
    input.addEventListener('change', function () {
      let subsFrequency = document.querySelector('.subs-frequency');
      let stuckLabels = document.querySelectorAll('.stuck_bundle_item > label');

      if (this.value === 'oneime_op') {
        if (document.querySelector('.ad-bundles')) {
          document.querySelector('.ad-bundles').classList.remove('subscription_activate');
          document.querySelector('.ad-bundles').classList.add('onetime_activate');
        }

        if (document.querySelector('.subscription_pricing')) {
          document.querySelector('.subscription_pricing').style.display = 'none';
        }
        if (document.querySelector('.one_time_pricing')) {
          document.querySelector('.one_time_pricing').style.display = 'flex';
        }

        if (subsFrequency) {
          subsFrequency.style.display = 'none';
        }
        if (sellingPlanInput) {
          sellingPlanInput.value = '';
        }

        if (stuckLabels.length > 0) {
          stuckLabels.forEach((stuck) => {
            let oneTimePerWash = stuck.getAttribute('data-onetime-per-wash');
            let perWashEl = stuck.querySelector('.content p #per_wash');
            if (perWashEl) {
              perWashEl.innerHTML = oneTimePerWash;
            }
          });
        }
      } else {
        if (document.querySelector('.ad-bundles')) {
          document.querySelector('.ad-bundles').classList.remove('onetime_activate');
          document.querySelector('.ad-bundles').classList.add('subscription_activate');
        }

        if (document.querySelector('.subscription_pricing')) {
          document.querySelector('.subscription_pricing').style.display = 'flex';
        }
        if (document.querySelector('.one_time_pricing')) {
          document.querySelector('.one_time_pricing').style.display = 'none';
        }

        if (subsFrequency) {
          subsFrequency.style.display = 'flex';
        }
        let selectedSellingID = document
          .querySelector('.subs-frequency .freq-options label > input:checked')
          .getAttribute('data-selling-id');

        if (sellingPlanInput && selectedSellingID) {
          sellingPlanInput.value = selectedSellingID;
        }

        if (stuckLabels.length > 0) {
          stuckLabels.forEach((stuck) => {
            let oneTimePerWash = stuck.getAttribute('data-subs-per-wash');
            let perWashEl = stuck.querySelector('.content p #per_wash');
            if (perWashEl) {
              perWashEl.innerHTML = oneTimePerWash;
            }
          });
        }
      }
    });
  });
});
